import { MdOutlineFilterAlt } from "react-icons/md";
function FilterBtn({
  onClick,
  disabled,
  Hidden,
  Icon = MdOutlineFilterAlt,
}: any) {
  //function FilterBtn({ onClick, disabled, Hidden }: any) {

  return (
    <button
      hidden={Hidden}
      className="refreshButton w-10 "
      onClick={onClick}
      disabled={disabled}
    >
      <Icon />
      {/* <MdOutlineFilterAlt /> */}
    </button>
  );
}

export default FilterBtn;
